import SearchResultList from "components/common/SearchResultList";
import UnitCat from "../UnitCat/UnitCat";
import { DlUnit } from "model/dl_unit/DlUnit";
import styled from "styled-components";
import { useCallback } from "react";
import UnitCatEdit from "components/admin/common/dl_unit/UnitCatEdit";

type UnitListProps = {
  units: DlUnit[];
  editMode?: boolean;
};

const UnitList = ({ units, editMode }: UnitListProps) => {
  const renderSingle = useCallback(
    (item: DlUnit, ind: number) =>
      !editMode ? (
        <UnitCat item={item} key={`unit_${ind + 1}`} />
      ) : (
        <UnitCatEdit unit={item} key={`unit_${ind + 1}`} />
      ),
    [editMode], // Dependency: only recreate when editMode changes
  );

  return (
    <Div>
      <SearchResultList<DlUnit> renderSingle={renderSingle} results={units} />
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-bottom: 1rem;
`;

export default UnitList;
